import { createSelector } from "reselect";

const aggregationInfoChart = (state) => state.aggregation.item;

export const getAggregationInfoChart = createSelector(
    aggregationInfoChart,
    (aggregationInfo) => {
        return Object.keys(aggregationInfo).length ? aggregationInfo : null;
    }
);
